// extracted by css-extract-rspack-plugin
export default {"container":"_e460f9f1"};